import { Component, OnInit } from '@angular/core';
import { AbstractModal, ModalButtonModel, ModalButtonType } from "@cv-invision/core";
import { Subject } from "rxjs";
import { DialogService } from "primeng/dynamicdialog";
import {
	CreateEditFieldValueComponent
} from "../../components/create-edit-field-value/create-edit-field-value.component";
import { TableConfig } from "@cv-invision/cv.invision-views.ux";

@Component({
	selector: 'cv-invision-ux-table-data-configuration',
	templateUrl: './table-data-configuration.component.html',
	styleUrls: [ './table-data-configuration.component.scss' ],
})
export class TableDataConfigurationComponent extends AbstractModal implements OnInit {

	expandedRows;
	tableData;
	parentTableHeaders: any [];
	childTableHeaders: any [];
	childForm: TableConfig;
	disabled: boolean;
	private atComponentDestroy = new Subject();

	constructor(private dialogService: DialogService) {
		super();
		this.expandedRows = true;
	}

	ngOnInit(): void {
		this.tableData = [];
		if (this.data) {
			this.parentTableHeaders = this.data.tableConfig?.parentHeaders;
			this.childTableHeaders = this.data.tableConfig?.childHeaders;
			this.childForm = this.data.tableConfig?.childForm;
			this.disabled = this.data.disabled;
			const tableData = this.data?.tableData;
			let i = 0;
			for (const tableInfo in tableData) {
				this.tableData.push({
					id: i,
					label: tableInfo,
					value: tableData[tableInfo].map((item: any, index: number) => {
						return {
							label: item,
							id: index,
						};
					})
				});
				i++;
			}
		}

		const cancelButton: ModalButtonModel = {
			name: 'close',
			text: 'Close',
			class: 'btn-sm',
			type: ModalButtonType.ACTION,
			action: this.onCancel.bind(this)
		};
		const confirmButton: ModalButtonModel = {
			name: 'save',
			text: 'Save',
			class: 'btn-sm cv-btn-blue ',
			type: ModalButtonType.ACTION,
			//disabled: (): boolean => !this.formService.form?.valid || this.saving,
			action: () => this.onSave(),
			//loading: (): boolean => this.saving,
			loadingText: 'Saving'
		};

		this.buttons.push(cancelButton);
		this.buttons.push(confirmButton);
	}

	/**
	 * event to dismiss the modal
	 */
	onDismiss(): void {
		this.onCancel();
	}

	/**
	 * event to call when save button is clicked
	 */
	onSave(): void {
		this.onSaveSuccess({data: this.tableData})
	}

	/**
	 * event to edit item
	 * @param row
	 * @param indexParent
	 */
	editRowItem(row): void {
		this.dialogService.open(CreateEditFieldValueComponent, {
			header: 'Edit',
			width: '21.3rem',
			closeOnEscape: false,
			dismissableMask: false,
			styleClass: 'add-config-type-modal',
			draggable: false,
			baseZIndex: 10001,
			data: {
				label: row.label,
				...{
					childForm: this.childForm
				}
			},
		}).onClose.subscribe((result) => {
			if (result && result.data) {
				row.label = result.data.label;
			}
		});
	}

	/**
	 * event to open modal to create a new field data
	 */
	addItemData(index?: number): void {
		this.dialogService.open(CreateEditFieldValueComponent, {
			header: 'Add ',
			width: '21.3rem',
			closeOnEscape: false,
			dismissableMask: false,
			styleClass: 'add-config-type-modal',
			draggable: false,
			baseZIndex: 10001
		}).onClose.subscribe((result) => {
			if (result?.data) {
				let sizeOfElement = this.tableData.length;
				if (index >= 0) {
					sizeOfElement = this.tableData[index].value.length;
					const newElement = {...result.data, sizeOfElement}
					this.tableData[index].value.push(newElement);
				} else {
					const newElement = {
						id: sizeOfElement,
						label: result.data.label,
						value: [],
					}
					this.tableData.push(newElement);

				}
			}
		});
	}

	/**
	 * event to remove items in table
	 * @param index
	 * @param removeParent
	 * @param parentIndex
	 */
	removeElement(index: number, removeParent: boolean, parentIndex: number = -1): void {
		if (removeParent) {
			this.tableData.splice(index, 1);
		}else {
			this.tableData[parentIndex].value.splice(index, 1);
		}
	}
}
